<template>
  <div class="flex justify-between flex-no-wrap">
    <div class="relative w-1/2 mr-1 mb-4 md:mb-0">
      <select class="text-NotoSansRegular text-sm block appearance-none w-full border border-gray-500 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-900"
        v-model="cityIndex" @change="emit" :disabled="isDisabled" :class="{ borderRed: !isValidate }">
        <option value="" disabled="disabled" hidden="hidden">選擇縣市</option>
        <option v-for="(item,index) in cityListData" :key="index" :value="index">{{ item.name }}</option>
      </select>
      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
      </div>
    </div>
    <div class="relative w-1/2 ml-1 mb-4 md:mb-0">
      <select class="text-NotoSansRegular text-sm block appearance-none w-full border border-gray-500 text-gray-900 py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-900"
        v-model="districtsIndex" @change="emit" :disabled="isDisabled" :class="{ borderRed: !isValidate }">
        <option value="" disabled="disabled" hidden="hidden">選擇區域</option>
        <option v-for="(item,index) in districtsListData" :key="index" :value="index">{{ item.zip }}-{{ item.name }}</option>
      </select>
      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import zipCodeJson from './zipCode.json'
export default {
  name: 'Address',

  props: {
    userCity: {
      type: String,
      default: ''
    },
    userDistrict: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isValidate: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      cityIndex: '',
      districtsIndex: '',
      zipData: zipCodeJson
    }
  },
  watch: {
    userCity: {
      handler (newVal, oldVal) {
        if ((newVal !== oldVal)) {
          this.setData()
        }
      }
    },
    userDistrict: {
      handler (newVal, oldVal) {
        if ((newVal !== oldVal)) {
          this.setData()
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'user'
    ]),
    cityListData () {
      let self = this
      return self.zipData ? self.zipData : null
    },
    districtsListData () {
      let self = this
      return self.zipData && self.cityIndex !== '' ? self.zipData[self.cityIndex].districts : null
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      let self = this
      if (self.zipData && self.userCity) {
        self.cityIndex = self.zipData.findIndex(x => x.name === self.userCity) === -1 ? 0 : self.zipData.findIndex(x => x.name === self.userCity)
      }
      if (self.zipData && self.userCity && self.userDistrict) {
        self.districtsIndex = self.zipData[self.cityIndex].districts.findIndex(x => x.name === self.userDistrict) === -1 ? 0 : self.zipData[self.cityIndex].districts.findIndex(x => x.name === self.userDistrict)
      }
      self.emit()
    },
    initIndex () {
      let self = this
      if (self.cityIndex && (self.districtsIndex >= self.zipData[self.cityIndex].districts.length)) {
        self.districtsIndex = 0
      }
    },
    async emit () {
      let self = this
      await self.initIndex()
      let array = {
        'zip_code': self.cityIndex !== '' && self.districtsIndex !== '' ? self.zipData[self.cityIndex].districts[self.districtsIndex].zip : '',
        'city': self.cityIndex !== '' ? self.zipData[self.cityIndex].name : '',
        'district': self.cityIndex !== '' && self.districtsIndex !== '' ? self.zipData[self.cityIndex].districts[self.districtsIndex].name : ''
      }

      self.$emit('getAddress', array)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
